import React from 'react';
import { NewUpdateContainerStyled } from './styled';
import { Buttons, Displays } from 'components'
import { withRouter } from 'navigations/withRouter';
import { RETAILER_ROUTE_PATH } from 'utils/constants/routePath';
import { retailerService } from 'apiServices';
import moment from 'moment';
import { IMG_PATH } from 'utils/constants/imgPath';
import { AlertControl } from 'components/Modals/Alert';
import { toast } from 'react-toastify';
import { scrollToTopPageFN } from 'utils/functions/scrollTopPage';

class NewUpdateContainer extends React.Component {
  state = { isLoading: true };

  componentDidMount() {
    scrollToTopPageFN()
    this.fetchData();
  }

  fetchData = async () => {
    let res = await retailerService.GET_RETAILER_NEW_DETAIL(this.props.router.params.id);

    if (res && res.status === 200) {
      this.setState({
        data: res.data,
        isLoading: false,
      })
    }
  };

  handleBack = () => {
    const { navigate, location } = this.props.router;
    if (location.key === 'default') {
      navigate(RETAILER_ROUTE_PATH.NEW, { replace: true });
    } else {
      navigate(-1);
    }
  };

  handleEdit = () => {
    this.props.router.navigate(`${RETAILER_ROUTE_PATH.NEW_EDIT}/${this.props.router.params.id}`);
  };

  handleDelete = () => {
    AlertControl.show({
      title: 'Confirm Delete',
      description: 'Do you want to delete it?',
      btnLabel1: 'Confirm',
      btnLabel2: 'Cancle',
      bgColor2: 'red',
      onEvent1: this.actionDelete
    });
  };

  actionDelete = async () => {
    let res = await retailerService.DELETE_RETAILER_NEW(this.props.router.params.id);

    if (res && res.status === 200) {
      toast.success('Delete success');
      this.props.router.navigate(RETAILER_ROUTE_PATH.NEW);
    } else {
      toast.error('Delete Failed');
    }
  };

  render() {
    const { isLoading, data } = this.state;
    return (
      <NewUpdateContainerStyled>
        {
          isLoading
            ?
            <div className='loading_show'>
              <Displays.Loading />
            </div>
            :
            <>
              <div className="title_show">New</div>
              <div className='label_zone'>
                <div>
                  สร้างเมื่อวันที่  {` `}
                  {data && moment(data.created_at).format('DD/MM/YYYY')}
                </div>
                <Displays.NoOff value={data ? data.is_active : true} />
              </div>
              <div className='box_form'>
                <div className='left_form'>
                  หัวข้อข่าว
                </div>
                <div className='right_form'>
                  {data?.title}
                </div>
              </div>
              <div className='box_form'>
                <div className='left_form'>
                  รูปภาพ
                </div>
                <div className='right_form'>
                  {
                    data && data.img_path && data.img_path !== '' &&
                    <img className='img_show' src={IMG_PATH + data?.img_path} alt='img' />
                  }
                </div>
              </div>
              <div className='box_form'>
                <div className='left_form'>
                  เนื้อข่าว
                </div>
                <div className='right_form'>
                  {data?.description}
                </div>
              </div>
              <div className='btn_action_price'>
                <div className='btn175'>
                  <Buttons.BtnNormal
                    theme_normal_btn
                    label="ย้อนกลับ"
                    onClick={this.handleBack}
                  />
                </div>
                <div className='btn175'>
                  <Buttons.BtnNormal
                    theme_normal_btn
                    label="แก้ไข"
                    onClick={this.handleEdit}
                  />
                </div>
                <div className='btn175'>
                  <Buttons.BtnNormal
                    theme_normal_btn
                    bgColor='red'
                    label="ลบ"
                    onClick={this.handleDelete}
                  />
                </div>
              </div>
            </>
        }
      </NewUpdateContainerStyled>
    );
  }
}

export default withRouter(NewUpdateContainer);